module.exports = __webpack_public_path__ + "static/media/YF95_2.d7dc673d.jpg";